import type { Document } from "@contentful/rich-text-types";
import type { Asset } from "contentful";

import { createUseQueryEntry } from "./client";

export interface ContentfulCardFields {
	image?: Asset;
	titleHighlightText: string;
	title: string;
	content: Document;
	callToActionText: string;
	callToActionUrl: string;
}

export const CONTENTFUL_PLAYGROUND_WELCOME_PAGE_FIRST_CARD = "6M860FaHZrzQJ5qIM1cg4k";
export const useQueryPlaygroundWelcomePageFirstCard = createUseQueryEntry<ContentfulCardFields>(
	CONTENTFUL_PLAYGROUND_WELCOME_PAGE_FIRST_CARD,
);

export const CONTENTFUL_PLAYGROUND_WELCOME_PAGE_SECOND_CARD = "72eTtUEFoi7F5fPoPLxYvq";
export const useQueryPlaygroundWelcomePageSecondCard = createUseQueryEntry<ContentfulCardFields>(
	CONTENTFUL_PLAYGROUND_WELCOME_PAGE_SECOND_CARD,
);

export const CONTENTFUL_PLAYGROUND_WELCOME_PAGE_THIRD_CARD = "35OUejhluL3sMjXPVtgyru";
export const useQueryPlaygroundWelcomePageThirdCard = createUseQueryEntry<ContentfulCardFields>(
	CONTENTFUL_PLAYGROUND_WELCOME_PAGE_THIRD_CARD,
);
